<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <!--  Personal info row  -->
        <div class="row pt-5">
            <!--  Personal image  -->
            <div v-if="getEmployee.image" class="col-12 col-xl-4 d-flex justify-content-center">
                <img :src="appUrl + getEmployee.image.contentUrl" alt="profile_photo" class="profile-img">
            </div>
            <div v-else class="col-12 col-xl-6 d-flex justify-content-center" style="border-radius: 50%">
                <img src="../../../public/images/employee.png" alt="profile_photo" class="profile-img-default">
            </div>

            <!--  Personal info  -->
            <div class="col-12 col-xl-6 mt-4 mt-xl-0 text-center">
                <div style="font-size: 24px; font-weight: 400; color: #000000">
                    {{ getEmployeeName(getEmployee) }}
                </div>
                <div v-if="optionsMonth.length" class="mt-1" style="font-size: 16px; color: #5b5b5b">
                    {{ getEmployeeGender(getEmployee) }},
                    {{ getEmployeeBirthDate(getEmployee) }}
                </div>

                <div class="mt-4" style="font-size: 16px; font-weight: 600; color: #8300C5;">{{ $t('person.contacts') }}</div>

                <div class="mt-1" style="font-weight: 600; color: #272727">
                    <span style="font-size: 16px; font-weight: 500; color: #5b5b5b">
                        {{ $t('person.telephone') + ': ' }}
                    </span>
                    {{ formatPhoneNumber(getEmployee.telephone) }}
                </div>
                <div v-if="getEmployee.user" style="font-weight: 600; color: #272727">
                    <span style="font-size: 16px; font-weight: 500; color: #5b5b5b">{{ $t('user.email') + ': ' }}</span>
                    {{ getEmployeeEmail(getEmployee) }}
                </div>
                <div v-if="getEmployee.employeeInformation" style="font-weight: 600; color: #272727">
                    <span v-if="getEmployee.employeeInformation.telegram" style="font-size: 16px; font-weight: 500; color: #5b5b5b">{{ $t('person.telegram') + ': ' }}</span>
                    {{ getEmployeeTelegram(getEmployee) }}
                </div>

                <div class="mt-4" v-if="getEmployee.additionalInformation" style="font-size: 16px; font-weight: 600; color: #8300C5;">
                    {{ $t('additionalInformation') }}
                </div>
                <div class="mt-1" v-if="getEmployee.additionalInformation">{{ getEmployee.additionalInformation }}</div>
            </div>
        </div>

        <table class="w-full d-none d-md-table mt-4">
            <thead>
                <tr class="h-11 bg-lightGray">
                    <th class="px-2">#</th>
                    <th class="px-2">{{ $t('product.name') }}</th>
                    <th class="px-2">{{ $t('unitOfMeasure.unitOfMeasure') }}</th>
                    <th class="px-2">{{ $t('amount') }}</th>
                    <th class="px-2">{{ $t('date') }}</th>
                    <th class="px-2">{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="bonusProduct of getEmployeeBonusProducts" :key="bonusProduct.id" class="h-11">
                    <td class="px-2">{{ bonusProduct.id }}</td>
                    <td class="px-2">{{ bonusProduct.product.name }}</td>
                    <td class="px-2">{{ showUnitOfMeasure(bonusProduct.product.unitOfMeasure) }}</td>
                    <td class="px-2">{{ parseFloat(bonusProduct.amount) }}</td>
                    <td class="px-2">
                        <span v-if="bonusProduct.updatedAt">{{ dateFormat(bonusProduct.updatedAt) }}</span>
                        <span v-else>-</span>
                    </td>
                    <td v-if="isCeo" class="px-2">
                        <div v-if="bonusProduct.hasGot" class="py-2 bg-green-400 text-white font-bold text-center rounded">
                            {{ $t('kpi.bonus.given') }}
                        </div>
                        <div v-else @click="giveBonusToEmployee(bonusProduct.id)" class="py-2 bg-red-400 text-white font-bold text-center rounded cursor-pointer">
                            {{ $t('kpi.bonus.give') }}
                        </div>
                    </td>
                    <td v-else class="px-2">
                        <div v-if="bonusProduct.hasGot" class="py-2 bg-green-400 text-white font-bold text-center rounded">
                            {{ $t('kpi.bonus.received') }}
                        </div>
                        <div v-else class="py-2 bg-red-400 text-white font-bold text-center rounded">
                            {{ $t('kpi.bonus.notReceived') }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <table class="w-full d-md-none">
            <tbody v-for="bonusProduct of getEmployeeBonusProducts" :key="bonusProduct.id" style="border-bottom: 5px solid #989797">
            <tr class="h-11">
                <th class="px-2 bg-lightGray">#</th>
                <td class="px-2 bg-lightGray">{{ bonusProduct.id }}</td>
            </tr>
            <tr class="h-11">
                <th class="px-2">{{ $t('product.name') }}</th>
                <td class="px-2">{{ bonusProduct.product.name }}</td>
            </tr>
            <tr class="h-11">
                <th class="px-2">{{ $t('unitOfMeasure.unitOfMeasure') }}</th>
                <td class="px-2">{{ showUnitOfMeasure(bonusProduct.product.unitOfMeasure) }}</td>
            </tr>
            <tr class="h-11">
                <th class="px-2">{{ $t('amount') }}</th>
                <td class="px-2">{{ parseFloat(bonusProduct.amount) }}</td>
            </tr>
            <tr class="h-11">
                <th class="px-2">{{ $t('date') }}</th>
                <td class="px-2">
                    <span v-if="bonusProduct.updatedAt">{{ dateFormat(bonusProduct.updatedAt) }}</span>
                    <span v-else>-</span>
                </td>
            </tr>
            <tr class="h-11">
                <th class="px-2">{{ $t('actions') }}</th>
                <td v-if="isCeo" class="px-2">
                    <div v-if="bonusProduct.hasGot" class="py-2 bg-green-400 text-white font-bold text-center rounded">
                        {{ $t('kpi.bonus.given') }}
                    </div>
                    <div v-else @click="giveBonusToEmployee(bonusProduct.id)" class="py-2 bg-red-400 text-white font-bold text-center rounded cursor-pointer">
                        {{ $t('kpi.bonus.give') }}
                    </div>
                </td>
                <td v-else class="px-2">
                    <div v-if="bonusProduct.hasGot" class="py-2 bg-green-400 text-white font-bold text-center rounded">
                        {{ $t('kpi.bonus.received') }}
                    </div>
                    <div v-else class="py-2 bg-red-400 text-white font-bold text-center rounded">
                        {{ $t('kpi.bonus.notReceived') }}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

    </Row>
</template>

<script>
import Row from "@/components/html/Row.vue";
import accessMixin from "@/mixin/accessMixin";
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "EmployeeBonusList",
    components: {Modal, Row},
    mixins: [accessMixin, dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            isLoading: false,
            isDisabled: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees/kpi/list'},
                {name: 'kpi.title'},
            ],
            search: {
                personId: null,
                page: 1
            },
            modalText: '',
            optionsMonth: [
                {text: this.$t('statistics.month.Jan')},
                {text: this.$t('statistics.month.Feb')},
                {text: this.$t('statistics.month.Mar')},
                {text: this.$t('statistics.month.Apr')},
                {text: this.$t('statistics.month.May')},
                {text: this.$t('statistics.month.Jun')},
                {text: this.$t('statistics.month.Jul')},
                {text: this.$t('statistics.month.Aug')},
                {text: this.$t('statistics.month.Sep')},
                {text: this.$t('statistics.month.Oct')},
                {text: this.$t('statistics.month.Nov')},
                {text: this.$t('statistics.month.Dec')},
            ],
        }
    },
    computed: {
        ...mapGetters(['getEmployeeBonusProducts', 'getEmployeeBonusProduct', 'getEmployee', 'getEmployeeBonusProductsTotalCount', 'isCeo'])
    },
    methods: {
        ...mapActions(['fetchEmployeeBonusProducts', 'fetchEmployeeBonusProduct', 'searchEmployeeBonusProducts', 'putEmployeeBonusProduct', 'fetchEmployee', 'setBreadcrumbItems']),
        giveBonusToEmployee(id) {
            this
                .putEmployeeBonusProduct({id: id})
                .then(() => {
                    this.fetchEmployeeBonusProducts()
                })
        },
        getEmployeeName(employee) {
            return employee.givenName + ' ' + employee.familyName + ' ' + employee.additionalName
        },
        getEmployeeGender(employee) {
            return employee.gender === 1 ? this.$t('person.gender.man') : this.$t('person.gender.woman')
        },
        getEmployeeAge(employee) {
            return new Date().getFullYear() - new Date(employee.birthday).getFullYear() + ' ' + this.$t('person.age')
        },
        getEmployeeBirthDate(employee) {
            if (employee['@type'] === 'Person') {
                let date = new Date(employee.birthday);
                
                return  this.$t('employee.wasBornDay') + ' ' +
                    date.getFullYear() + '-' + this.$t('person.year') + ' ' +
                    date.getDate() + '-' + this.optionsMonth[date.getMonth()].text;
            }
        },
        formatPhoneNumber(number) {
            if (number) {
                return number.replace(/\D+/g, '').replace(/(\d{3})(\d{2})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
            }
        },
        getEmployeeEmail(employee) {
            return employee.user ? employee.user.email : ''
        },
        getEmployeeTelegram(employee) {
            return employee.employeeInformation.telegram ? employee.employeeInformation.telegram : ''
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this
            .fetchEmployee(this.$route.params.id)
            .then(() => {
                this.$root.showOverlay = false
            })

        this.search.personId = this.$route.params.id

        this
            .searchEmployeeBonusProducts(this.search)
            .then(() => {
                this.$root.showOverlay = false
            })
            .catch((reason) => {
                this.$root.showOverlay = false

                this.modalText = reason
                this.$bvModal.show('modal_show')
            })
    }
}
</script>

<style scoped>
.profile-img {
    max-height: 250px;
}
</style>
